import { AccountManager } from './../../model/accountManager';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SiteUser, UserLogo } from '../../model/user';
import { UserService } from '../../core/services/user/user.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../environments/environment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core'; 
import { LogoChangeService } from '../../core/services/logoChange/logo-change.service';

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [FormsModule, CommonModule, MatIconModule, MatFormFieldModule, MatSelectModule, MatOptionModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent implements OnInit {
  public users: SiteUser[] = [];
  public logos: UserLogo[] = [];
  public selectedLogo: UserLogo | null = null;
  public storageUrl = environment.AZURE_STORAGE_URL;

  constructor(
    private userService: UserService,
    private logoChangeService: LogoChangeService
  ) {}

  ngOnInit(): void {
    this.loadUsers();
    this.loadUserLogos();
  }

  public onLogoSelected(logo: UserLogo): void {
    this.selectedLogo = logo;
  }

  public applyChanges(user, selectedLogo): void {
    const logoId = selectedLogo ? selectedLogo.id : -1;
    this.userService.saveUserLogo(user.id, logoId).subscribe({
      next: () => {
        const currentUser = JSON.parse(localStorage.getItem('user'));
        if (currentUser && currentUser.accountManager.userId === user.id) {
          currentUser.accountManager.logoName = selectedLogo ? selectedLogo.name : null;
          localStorage.setItem('user', JSON.stringify(currentUser));
          const newLogoUrl = selectedLogo ? this.storageUrl + selectedLogo.name : null;
          this.logoChangeService.updateLogo(newLogoUrl);
        }
        this.loadUsers();
        this.loadUserLogos();
      },
      error: (err) => {
        console.error('Error saving user logo:', err);
      }
    });
  }

  private loadUsers(): void {
    this.userService.getUsers().subscribe({
      next: (users: SiteUser[]) => {
        this.users = users;
      },
      error: (err) => {
        console.error('Error loading users:', err);
      }
    });
  }

  private loadUserLogos(): void {
    this.userService.getUserLogos().subscribe({
      next: (logos: UserLogo[]) => {
        this.logos = logos;
      },
      error: (err) => {
        console.error('Error loading user logos:', err);
      }
    });
  }

  
}
